import React, { useState } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import AudienceHero from '../../components/AudienceHero';
import HowItWorks from '../../components/HowItWorks';
import MindsetQuizPromo from '../../components/MindsetQuizPromo';
import SimplifiedPricing from '../../components/SimplifiedPricing';
import { LeadMagnetPromo, PARENT_PLAYBOOK_CONFIG } from '../../components/LeadMagnetPromo';
import TestimonialsSection from '../../components/TestimonialsSection';
import FinalCTABanner from '../../components/FinalCTABanner';
import PrivacyPolicy from '../../components/PrivacyPolicy';
import { CALENDLY_URL, LOGO_URL, INSTAGRAM_URL } from '../../lib/siteConfig';

/**
 * /parents — dedicated landing for parents of competitive athletes.
 */
export default function ParentsPage() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="parents-page">
      <Navbar calendlyLink={CALENDLY_URL} logoUrl={LOGO_URL} />
      <main>
        <AudienceHero
          testIdPrefix="parents-hero"
          eyebrow="For Parents"
          headline="Support your athlete’s mental game — without adding pressure."
          subhead="You see the talent. You also see the freeze. Get the tools, language, and consultation to help your athlete build confidence at the dinner table, on the car ride home, and the moment before they walk onto the field."
          primaryCta={{ href: CALENDLY_URL, label: 'Book a Discovery Call', external: true }}
          secondaryCta={{ href: '/playbook', label: 'Get the Free Car-Ride-Home Playbook' }}
        />

        {/* How it works for parents — 3-step path before resources */}
        <HowItWorks variant="parent" />

        <LeadMagnetPromo config={PARENT_PLAYBOOK_CONFIG} />
        <MindsetQuizPromo />
        <SimplifiedPricing calendlyLink={CALENDLY_URL} />
        <TestimonialsSection />

        <FinalCTABanner
          headline="Have a quick story to share? Let’s talk."
          subhead="A 30-minute Discovery Call is free and no-pressure. Bring the moment that’s been on your mind — we’ll map a plan that fits your athlete, your family, and your season."
          primaryHref={CALENDLY_URL}
          primaryLabel="Book a Discovery Call"
          secondaryHref="/playbook"
          secondaryLabel="Get the Free Playbook"
        />
      </main>
      <Footer
        calendlyLink={CALENDLY_URL}
        instagramLink={INSTAGRAM_URL}
        logoUrl={LOGO_URL}
        onPrivacyClick={() => setPrivacyOpen(true)}
      />
      <PrivacyPolicy open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
    </div>
  );
}
